'use client';

import React from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';

const BRAND = '#3757FF';

export default function Footer() {
    return (
        <footer className="py-14 px-6 md:px-10" style={{ background: '#fff', borderTop: '1px solid rgba(55,87,255,0.1)' }}>
            <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-start justify-between gap-10">
                {/* Left */}
                <div className="flex flex-col gap-4 max-w-xs">
                    <Link href="/" className="flex items-center gap-1.5">

                        <AppLogo size={40} />

                        <span className="font-bold text-base text-foreground font-800" style={{ color: '#0D0D0D' }}>
                            Wisly
                        </span>
                    </Link>
                    <p className="text-sm leading-relaxed" style={{ color: '#888' }}>
                        The connected education platform. Built by{' '}
                        <Link href="https://codigo.com.ng" target='_blank' className="font-600 transition-colors" style={{ color: BRAND }}>Codigo</Link>.
                    </p>
                </div>

                {/* Right */}
                <div className="flex flex-col gap-5 md:items-end">
                    <div className="flex flex-wrap gap-x-8 gap-y-3">
                        {[
                            { label: 'Home', href: '/' },
                            { label: 'Wisly Learn', href: '/learn' },
                            { label: 'Wisly Studio', href: '/studio' },
                            { label: 'Privacy', href: '/privacy' },
                            { label: 'Terms', href: '/terms' },
                        ].map(link => (
                            <a
                                key={link.label}
                                href={link.href}
                                className="text-sm font-600 transition-colors"
                                style={{ color: '#888' }}
                                onMouseEnter={e => { (e.currentTarget as HTMLElement).style.color = BRAND; }}
                                onMouseLeave={e => { (e.currentTarget as HTMLElement).style.color = '#888'; }}
                            >
                                {link.label}
                            </a>
                        ))}
                    </div>
                    <p className="text-xs" style={{ color: '#bbb' }}>
                        © {new Date().getFullYear()} Wisly by Codigo Foundry Limited. All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
}
